import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE_CAMPAIGN_QUERY = {
  'list': [],
  'loading': false,
  'chassisList': [],
  'loadingChassisList': false,
};

export const campaignQuery = (state, action) => {
  return createReducer(INITIAL_STATE_CAMPAIGN_QUERY, {
    [ActionTypes.FETCHING_CAMPAIGN_CHASSIS_LIST]: (state, action) => ({
      ...state,
      'loadingChassisList': true,
    }),
    [ActionTypes.FETCHED_CAMPAIGN_CHASSIS_LIST]: (state, action) => ({
      ...state,
      'loadingChassisList': false,
      'chassisList': action.response.data,
    }),
    [ActionTypes.FETCHED_CAMPAIGN_CHASSIS_LIST_FAILED]: (state, action) => ({
      ...state,
      'loadingChassisList': false,
      'chassisList': [],
    }),
    [ActionTypes.FETCHING_CAMPAIGN_LIST_BY_CHASSIS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_CAMPAIGN_LIST_BY_CHASSIS]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.FETCHED_CAMPAIGN_LIST_BY_CHASSIS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    [ActionTypes.CLEAR_CAMPAIGN_CHASSIS_LIST]: (state, action) => ({
      ...state,
      'loadingChassisList': false,
      'chassisList': [],
    }),
    [ActionTypes.CLEAR_CAMPAIGN_LIST_BY_CHASSIS]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
  })(state, action);
};

